import { useStyles } from '@team-griffin/stylr';
import { useBreakpoints } from '@uds/responsive';
import { gu2px, Theme } from '@uds/theme-utils';

export default ({ theme: { spacing } }: { theme: Theme }) => {
  const { isMinSm, isMinMd } = useBreakpoints();
  return useStyles(
    {
      default: {
        grid: {
          display: 'grid',
          columnGap: gu2px(2, spacing),
          rowGap: gu2px(1, spacing),
        },
      },

      isMinSm: {
        grid: {
          rowGap: gu2px(2, spacing),
        },
      },

      isMinMd: {
        grid: {
          gridTemplateColumns: 'repeat(2, 1fr)',
        },
      },
    },
    {
      isMinSm,
      isMinMd,
    },
  );
};
